/* eslint-disable max-len */
import {ReloadOutlined, CloseOutlined} from '@ant-design/icons';
import {Modal, Carousel, Button, Image} from 'antd';
import type {CarouselRef} from 'antd/es/carousel';
import React, {useState, useRef, useEffect} from 'react';

import {drawerZIndex} from '../../../constants/Common';

import {ReactComponent as LeftArrowTour} from './../../../assets/icons/LeftArrowTour.svg';
import {ReactComponent as RightArrowTour} from './../../../assets/icons/RightArrowTour.svg';
import Tour1 from './../../../assets/Tour1.webp';
import Tour2 from './../../../assets/Tour2.webp';
import Tour3 from './../../../assets/Tour3.webp';
import Tour4 from './../../../assets/Tour4.webp';
import Tour5 from './../../../assets/Tour5.webp';
import Tour6 from './../../../assets/Tour6.webp';

interface Slide {
  image: JSX.Element;
  title: string;
  description: string;
}

interface TakeTourProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
}

const TakeTour: React.FC<TakeTourProps> = ({visible, setVisible, onClose}) => {
  const carouselRef = useRef<CarouselRef | null>(null);
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [isTransitioning, setIsTransitioning] = useState<boolean>(false);

  const slides: Slide[] = [
    {
      image: (
        <Image
          src={Tour1}
          loading="lazy"
          placeholder={
            <Image
              preview={false}
              src="data:image/png;base64,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"
              width={200}
            />
          }
          preview={false}
        />
      ),
      title: 'Welcome to Bharat Carbon!',
      description: `Your trusted platform for tracking and managing your
        organization’s carbon footprint. We’re here to empower
        your journey toward sustainability with innovative carbon
        management solutions.`
    },
    {
      image: (
        <Image src={Tour2} loading="lazy" placeholder={true} preview={false} />
      ),
      title: 'First, add organization data!',
      description: `Start by entering your organization's essential details
        such as operational information, facilities, and relevant
        background data. This step enables our system to tailor
        the carbon analysis specifically to your enterprise.`
    },
    {
      image: (
        <Image src={Tour3} loading="lazy" placeholder={true} preview={false} />
      ),
      title: 'Next, add activity data!',
      description: `Input your operational activity data including energy
        usage, transportation, and production processes. This
        information helps us accurately map out your emissions
         profile and calculate your carbon footprint.`
    },
    {
      image: (
        <Image src={Tour4} loading="lazy" placeholder={true} preview={false} />
      ),
      title: 'Your carbon footprint is calculated! View Report',
      description: `Input your operational activity data including energy 
          usage, transportation, and production processes. This
         information helps us accurately map out your emissions
          profile and calculate your carbon footprint.`
    },
    {
      image: (
        <Image src={Tour5} loading="lazy" placeholder={true} preview={false} />
      ),
      title: 'Now, comply with regulatory frameworks!',
      description: `With your report in hand, ensure that your organization
        aligns with the latest local and international environmental
         regulations. Our tools help you navigate compliance requirements
         and avoid potential penalties.`
    },
    {
      image: (
        <Image src={Tour6} loading="lazy" placeholder={true} preview={false} />
      ),
      title: 'Decarbonize your organization',
      description: `Finally, leverage our strategies and best practices to reduce
         your carbon emissions and drive sustainable growth. 
         Take proactive steps to decarbonize, enhancing both your
         environmental performance and corporate reputation.`
    }
  ];

  // Reset to first slide whenever modal becomes visible
  useEffect(() => {
    if (visible) {
      setCurrentSlide(0);
      carouselRef.current?.goTo(0, false); // Instant jump to first slide
    }
  }, [visible]);

  const goToSlide = (index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    carouselRef.current?.goTo(index);
  };

  const nvaNext = () => {
    if (isTransitioning) return;

    const nextIndex = currentSlide + 1;
    if (nextIndex >= slides.length) {
      setVisible(false);
      onClose(true);
    } else {
      goToSlide(nextIndex);
    }
  };

  const nvaPrev = () => {
    if (isTransitioning || currentSlide === 0) return;
    goToSlide(currentSlide - 1);
  };

  const handleReset = () => {
    goToSlide(0);
  };

  const handleClose = () => {
    setVisible(false);
    onClose(true);
  };

  return (
    <Modal
      open={visible}
      onCancel={handleClose}
      footer={null}
      closable={true}
      maskClosable={true}
      destroyOnClose={true}
      width={540}
      className="onboarding-modal"
      zIndex={drawerZIndex}
    >
      <Carousel
        ref={carouselRef}
        dots={{className: 'custom-dots'}}
        afterChange={(current) => {
          setCurrentSlide(current);
          setIsTransitioning(false);
        }}
      >
        {slides.map((slide, index) => (
          <div key={index} className="carousel-slide">
            {slide.image}
            <div className="slide-content">
              <h2>{slide.title}</h2>
              <p>{slide.description}</p>
            </div>
          </div>
        ))}
      </Carousel>

      <div className="navigation-buttons">
        <Button
          shape="circle"
          icon={<LeftArrowTour />}
          onClick={nvaPrev}
          disabled={currentSlide === 0}
          className="nav-button"
        />
        <div className="pagination-dots">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentSlide ? 'active' : ''}`}
            />
          ))}
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          {currentSlide === slides.length - 1 && (
            <Button
              shape="circle"
              icon={<ReloadOutlined />}
              onClick={handleReset}
              className="nav-button reload-button"
            />
          )}
          <Button
            shape="circle"
            icon={
              currentSlide === slides.length - 1 ? (
                <CloseOutlined />
              ) : (
                <RightArrowTour />
              )
            }
            onClick={nvaNext}
            className={
              currentSlide === slides.length - 1
                ? 'next-button-danger'
                : 'next-button'
            }
          />
        </div>
      </div>
    </Modal>
  );
};

export default TakeTour;
